<template>
	<div class="position-error" @click="$emit('close')">
		<div class="popup">
			<p>För att kunna se var du är på kartan behöver du tillåta din webbläsare att veta din position.</p>
			<button>Ok</button>
		</div>
	</div>
</template>

<script>
export default {

}
</script>

<style scoped>
	.position-error {
		position: absolute;
		background-color: #000000aa;
		z-index: 1001;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;

		display: flex;
		flex-flow: column nowrap;
		align-items: center;
		justify-content: center;
	}

	.popup {
		background-color: white;
		padding: 1em 3em;
		border-radius: 1em;
		max-width: 370px;

		display: flex;
		flex-flow: column nowrap;
		justify-content: center;
	}

	button {
		border: none;
		background: black;
		color: white;
		border-radius: 30px;
		padding: .5em 1em;
		font-family: 'Poppins', sans-serif;
	}

	button:focus {
		outline: none;
		box-shadow: 0px 0px 4px black;
	}

	p {
		margin-bottom: 2em;
	}
</style>